import React from 'react';
import { Tooltip } from '@mui/material';

const AlphaBadge = ({ style, isMobile }) => {
    const defaultStyle = {
        display: 'inline-block',
        backgroundColor: 'var(--error-color, #ff4d4f)',
        color: 'white',
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '0.8em',
        marginLeft: '8px',
        fontWeight: 'normal',
        cursor: 'help',
        ...style
    };

    const tooltipContent = (
        <div style={{ padding: '8px', maxWidth: '300px', textAlign: 'left' }}>
            <p style={{ margin: '0 0 8px 0' }}>This is an experimental version of NanoTradingCopilot that:</p>
            <ul style={{ margin: '0', paddingLeft: '20px' }}>
                <li>May contain bugs or incomplete features</li>
                <li>Could have frequent updates and changes</li>
                <li>May have limited functionality</li>
                <li>Is being actively developed and improved</li>
            </ul>
        </div>
    );

    return (
        <Tooltip
            title={tooltipContent}
            arrow
            placement="bottom"
        >
            <span style={defaultStyle}>
                Alpha
            </span>
        </Tooltip>
    );
};

export default AlphaBadge; 